export default __webpack_public_path__ + "static/media/img_introduce_in_detail_1.8af73e08.png";